window.orejimeConfig = {
    elementID: "orejime",
    appElement: null,
    cookieName: "orejime",
    cookieExpiresAfterDays: 365,
    privacyPolicy: "https://planet.ctec-leasing.com/uploads/library/internal/20191024220632Ctec_Politique_Vie_Privée.pdf",
    default: true,
    mustConsent: false,
    mustNotice: false,
    implicitConsent: false,
    logo: false,
    debug: true,
    translations: {
        en: {
            "consentModal":{
                "title":"Our site uses cookies","description":"What are cookies ? What type of cookies do we use and why?",
                "privacyPolicy":{
                    "name":"cookie policy",
                    "text":"Find out in our {privacyPolicy}."
                },
                "privacyPolicyNotice":{
                    "name":"cookie policy",
                    "text":"View our {privacyPolicy} to know more."
                }
            },
            "consentNotice":{
                "changeDescription":"Changes have been done since your last visit, please update your cookie consent.",
                "description":"This website uses cookies. The essential and functional cookies are used to get our site working properly and thus can't be disabled. Other cookies are used for analytical purposes and will be added if you accept their use.",
                "learnMore":"Setup the cookies"
            },
            "accept":"Allow the use of analytics cookies",
            "acceptAll":"Accept all optional cookies",
            "save":"Confirm you choice",
            "saveData":"Save my setup about the collected information",
            "decline":"Got it",
            "declineAll":"Decline all optional cookies",
            "close":"Close",
            "enabled":"Enabled",
            "disabled":"Disabled",
            "app":{
                "optOut":{
                    "title":"(opt-out)",
                    "description":"These cookies are enabled by default (you can disable them anyhow)"
                },
                "required":{
                    "title":"(always required)",
                    "description":"These cookies are required"
                },
                "optional":{
                    "title":"(optional)",
                    "description":"These cookies are optional"
                },
                "purposes":"Purposes",
                "purpose":"Purpose"
            },
            "poweredBy":"Powered by Orejime",
            "newWindow":"new window",
            "essential":{
                "description":"These cookies are needed purely for technical purposes, to get this website running properly. Due this technical need, only an information obligation applies, these will be applied when browsing our website."
            },
            "functional":{
                "description":"Your not disable these cookies if you wish to browse this website with optimal functionalities, you may choose to disable them by selecting so in the cookie placement choice."
            },
            "analytics":{
                "description":"Analytical cookies are allow us to determine how may times a page is accessed. We only use those informations to enable us to provide you with better services in the futur and not to track you activity across your surfing activity. These are only used after you accept to their placement."
            },
            "purposes":{"server":"base services","analytics":"analytics"}
        },
        fr: {
            "consentModal":{
                "title":"Notre site utilise des cookies","description":"Qu\u2019est-ce qu\u2019un cookie ? Quels cookies utilisons-nous et pourquoi?",
                "privacyPolicy":{
                    "name":"politique en mati\u00e8re de cookies",
                    "text":"D\u00e9couvrez-le dans notre {privacyPolicy}."
                },
                "privacyPolicyNotice":{
                    "name":"politique en mati\u00e8re de cookies",
                    "text":"Consultez notre {privacyPolicy} pour en savoir plus."
                }
            },
            "consentNotice":{
                "changeDescription":"Des modifications ont eu lieu depuis votre derni\u00e8re visite, merci de mettre \u00e0 jour votre consentement.",
                "description":"Le pr\u00e9sent site internet place des cookies. Les cookies essentiels et fonctionnels sont n\u00e9cessaires au bon fonctionnement du site Internet et ne peuvent pas \u00eatre refus\u00e9s. D\u2019autres cookies sont utilis\u00e9s \u00e0 des fins statistiques (cookies d\u2019analyse) et ne seront plac\u00e9s que si vous en acceptez le placement.",
                "learnMore":"Param\u00e9trer les cookies"
            },
            "accept":"Continuer avec les cookies d'analyse",
            "acceptAll":"Activer tous les cookies optionnels",
            "save":"Confirmer mon choix",
            "saveData":"Sauvegarder ma configuration sur les informations collect\u00e9es",
            "decline":"Ok, j\u2019ai compris",
            "declineAll":"Refuser tous les cookies optionnels",
            "close":"Fermer",
            "enabled":"Activ\u00e9",
            "disabled":"D\u00e9sactiv\u00e9",
            "app":{
                "optOut":{
                    "title":"(se retirer)",
                    "description":"Ces cookies sont charg\u00e9s par d\u00e9faut (mais vous pouvez les d\u00e9sactiver)"
                },
                "required":{
                    "title":"(toujours requis)",
                    "description":"Ces cookies sont toujours requis"
                },
                "optional":{
                    "title":"(optionnels)",
                    "description":"Ces cookies sont optionnels"
                },
                "purposes":"Utilisations",
                "purpose":"Utilisation"
            },
            "poweredBy":"Propuls\u00e9 par Orejime",
            "newWindow":"nouvelle fen\u00eatre",
            "essential":{
                "description":"Ces cookies sont n\u00e9cessaires pour des raisons purement techniques pour une visite normale du site Internet. Vu la n\u00e9cessit\u00e9 technique, seule une obligation d'information s'applique, et ces cookies sont plac\u00e9s d\u00e8s que vous acc\u00e9dez au site Internet."
            },
            "functional":{
                "description":"Vous ne pouvez pas refuser ces cookies si vous d\u00e9sirez naviguer de mani\u00e8re optimale sur ce site Internet, mais ils ne sont plac\u00e9s qu'apr\u00e8s qu'un choix aura \u00e9t\u00e9 effectu\u00e9 concernant le placement de cookies."
            },
            "analytics":{
                "description":"Il s'agit de cookies qui nous permettent de savoir combien de fois une page d\u00e9termin\u00e9e a \u00e9t\u00e9 consult\u00e9e. Nous utilisons ces informations uniquement pour am\u00e9liorer le contenu de notre site Internet. Ces cookies ne sont plac\u00e9s que si vous en acceptez le placement."
            },
            "purposes":{"server":"service de base","analytics":"statistiques"}
        },
        nl: {
            "consentModal":{
                "title":"Onze site maakt gebruik van cookies","description":"Wat is een cookie ? Welke cookies gebruiken we en waarom?",
                "privacyPolicy":{
                    "name":"cookiebeleid",
                    "text":"Lees er meer over in ons {privacyPolicy}."
                },
                "privacyPolicyNotice":{
                    "name":"cookiebeleid",
                    "text":"Lees er meer over in ons {privacyPolicy}."
                }
            },
            "consentNotice":{
                "changeDescription":"Er waren wijzigingen sinds uw laatste bezoek, werk uw voorkeuren bij.",
                "description":"Deze website maakt gebruik van cookies. De essenti\u00eble en functionele cookies zijn nodig voor het goed functioneren van de website en kunnen niet worden geweigerd. Andere cookies worden gebruikt voor statistische doeleinden (analytische cookies) en worden enkel geplaatst nadat je een keuze gemaakt hebt.",
                "learnMore":"Cookies instellen"
            },
            "accept":"Verdergaan met analytische cookies",
            "acceptAll":"Activeer alle optionele cookies",
            "save":"Mijn keuze bevestigen",
            "saveData":"Mijn configuratie voor de informatievergaring opslaan",
            "decline":"Ok, ik begrijp het",
            "declineAll":"Deactiveer alle optionele cookies",
            "close":"Sluiten",
            "enabled":"Geactiveerd",
            "disabled":"Gedesactiveerd",
            "app":{
                "optOut":{
                    "title":"(afmelden)",
                    "description":"Deze cookies worden standaard geladen (maar u kunt ze uitschakelen)"
                },
                "required":{
                    "title":"(altijd verplicht)",
                    "description":"Deze cookies zijn altijd nodig"
                },
                "optional":{
                    "title":"(facultatief)",
                    "description":"Deze cookies zijn optioneel"
                },
                "purposes":"Doeleinden",
                "purpose":"Doeleinde"
            },
            "poweredBy":"Aangedreven door Orejime",
            "newWindow":"nieuw venster",
            "essential":{
                "description":"Deze cookies zijn nodig om puur technische redenen voor een normaal bezoek aan de website. Gezien de technische noodzaak geldt alleen een informatieverplichting, en deze cookies worden geplaatst zodra je de website bezoekt."
            },
            "functional":{
                "description":"U kunt deze cookies niet weigeren als u op deze website wilt surfen, maar ze worden pas geplaatst nadat er een keuze is gemaakt met betrekking tot het plaatsen van cookies."
            },
            "analytics":{
                "description":"Deze cookies gebruiken we onder meer om te weten hoeveel keer een bepaalde pagina wordt gelezen. Deze informatie gebruiken we enkel om de inhoud van onze website te verbeteren. Deze cookies worden enkel geplaatst nadat u hiervoor uw akkoord hebt gegeven."
            },
            "purposes":{"server":"basisdienst","analytics":"statistieken"}
        }

    },
    apps: [
        {"name":"essential","title":"Cookies essentiels","purposes":["server"],"cookies":[],"required":true,"optout":true,"default":true,"apps_in_category":"essential"},
        {name: "analytics",title: "Cookies d'analyse",cookies: ["_ga"],purposes: ["analytics"],required: false,optOut: false,default: true,"apps_in_category":"google analytics"}
    ],
}
